import FinancePaymentsApi from 'api/admins/finance-payments-api'
import { TitlePage } from 'components/atoms'
import FinancePaymentsView from 'domains/finance/payments/view/finance-payments-view'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const FinancePaymentsDetailPage = ({ pageUtils }) => {
  const { id } = useParams()
  const [ payment, setPayment ] = useState({})
  const [ historyList, setHistoryList ] = useState([])
  const [ historyDetail, setHistoryDetail ] = useState({})
  const [ isLoading, setIsLoading ] = useState(true)

  const updateDownPayment = (fullyPaid, downPayment) => {
    if(!fullyPaid && downPayment === 0){
      alert("Mohon isi Down Payment baru")
      return
    }
    setIsLoading(true)

    FinancePaymentsApi.updateDownPayment({
      paymentId: id,
      fullyPaid,
      downPayment,
    })
      .then((response) => {
        if(response.status === 200){
          fetchPayment()
        }
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
      .finally(() => { setIsLoading(false) })
  }
  const confirmManualTransfer = () => {
    setIsLoading(true)

    FinancePaymentsApi.confirm({ paymentId: id })
      .then((response) => {
        if(response.status === 200){
          fetchPayment()
        }
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
      .finally(() => { setIsLoading(false) })
  }
  const rejectManualTransfer = () => {
    setIsLoading(true)

    FinancePaymentsApi.reject({ paymentId: id })
      .then((response) => {
        if(response.status === 200){
          fetchPayment()
        }
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
      .finally(() => { setIsLoading(false) })
  }
  const fetchPayment = () => {
    setIsLoading(true)

    FinancePaymentsApi.show({ paymentId: id })
      .then((response) => { setPayment(response.data.data) })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
      .finally(() => { setIsLoading(false) })
  }
  
  const fetchHistoryList = () => {
    FinancePaymentsApi.listHistory({ dealId: payment.deal.id })
      .then((response) => { setHistoryList(response.data?.data?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))) })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
  }
  const fetchHistoryDetail = (id) => {
    FinancePaymentsApi.getHistory({ historyId: id })
      .then((response) => { setHistoryDetail(response.data.data) })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
  }
  const clearHistoryDetail = () => {
    setHistoryDetail({})
  }

  useEffect(() => {
    fetchPayment()
  }, [ id ])

  return (
    <>
      <TitlePage mainTitle={ 'Finance Payment' }/>
      <FinancePaymentsView
        confirmManualTransfer={ confirmManualTransfer }
        rejectManualTransfer={ rejectManualTransfer }
        fetchPayment={ fetchPayment }
        updateDownPayment={ updateDownPayment }
        payment={ payment }
        fetchHistoryList={ fetchHistoryList }
        fetchHistoryDetail={ fetchHistoryDetail }
        clearHistoryDetail={ clearHistoryDetail }
        historyList={ historyList }
        historyDetail={ historyDetail }
        isLoading={ isLoading }
      />
    </>
  )
}

FinancePaymentsDetailPage.propTypes = propTypes

export default FinancePaymentsDetailPage